// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tqp2","label":"styles_label__19ngo"};